import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Paper,
  TableSortLabel,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import AppButton from "../../../components/CommonReusableComponent/AppButton/AppButton";
import {
  exportToExcel,
  addCurrentTimeInTimeStamp,
} from "../../../common/CommonFunctions";
// import MUITableSearch from "../../../components/MUITable/MUITableSearch";
import AppInputField from "../../../components/CommonReusableComponent/AppInputField/AppInputField";
import MUIDatePicker from "../../../components/MUIDatePicker/MUIDatePicker";
import {
  getComparator,
  handleChangePage,
  handleChangeRowsPerPage,
  // requestSearch,
  handleRequestSort,
  stableSort,
} from "../../../common/MuiTableFunctions.config";
import {
  complianceStatusConfig,
  verificationStatusConfig,
  varificationStatus_should_be_disable
} from "./AuditMasterDataTable.config";
import dayjs from "dayjs";
import { Input } from "reactstrap";
import { Icons } from "../../../config/MuiIcons.config";
import { AppTheme } from "../../../theme/App.theme";
import UploadEvidenceForNCPointModal from "./UploadEvidenceForNCPointModal";
import UploadAddIcon from "../../../assets/images/Upload-Add.svg"
import UploadEditIcon from "../../../assets/images/Upload-Edit.svg"

const useStyles = makeStyles((theme) => ({
  menuItem: {
    display: "grid",
  },
}));

const DataTableToUpdateActivityStatusForAudit = ({
  RowData = [],
  Columns,
  RowsToDisplay,
  OptionsForRowsPerPage,
  HoverEffect,
  DenseTable,
  RequiredSearch,
  DataToBeExport,
  FileNameForExportData,
  HeaderFontSize,
  // IsOutSideSearch,

  // Realated to activity status update
  AuditData,
  HandleChangeInActivityStatusTable,
  IsAdmin,
  IsSuperAdmin,
  IsAuditor,
  IsAuditee,
  IsViewMode,
  IsAuditReviewPendingAtAuditor,
  IsAuditReviewedByAuditor,
  IsAuditReviewedByAuditee,
  IsAuditInClosePendingStatus,
  IsAuditInClosedStatus,
  IsAuditStatusNew,
  IsAuditStarted,

  // Related to evidence upload
  UploadEvidenceModalState,
  HandleToggleUploadEvidenceModalState
}) => {
  const classes = useStyles();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState(Columns[0].id);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(RowsToDisplay || 10);

  // States related to evidence upload
  const [activityObjData, setActivityObjData] = useState(null);

  const capaEnabledStatus = {
    notConfirmed: "Not Confirmed",
    areaOfImprovement: "Area for Improvement",
  };

  const targetDateEnabledStatus = {
    notConfirmed: "Not Confirmed",
    areaOfImprovement: "Area for Improvement",
  };

  // const isCapaDisabled = (currentComplianceStatus) => {
  //   const isDisabled =
  //     currentComplianceStatus === capaEnabledStatus.notConfirmed ||
  //     currentComplianceStatus === capaEnabledStatus.areaOfImprovement
  //       ? true
  //       : false;
  //   return isDisabled;
  // };

  // Function to display the evidence upload icon based on conditions
  const displayEvidenceUploadIcon = (currentComplianceStatus) => {
    const isDisabled =
      currentComplianceStatus === capaEnabledStatus.notConfirmed ||
      currentComplianceStatus === capaEnabledStatus.areaOfImprovement
        ? true
        : false;
    return isDisabled;
  };

  const disableFieldsForSelectedUser = () => {
    const isDisabled = (!IsAuditee && !IsAuditor) ? true : false;
    return isDisabled;
  }; 

  const isTargetDateDisabled = (currentComplianceStatus) => {
    const isDisabled =
      currentComplianceStatus === targetDateEnabledStatus.notConfirmed ||
      currentComplianceStatus === targetDateEnabledStatus.areaOfImprovement
        ? true
        : false;
    return isDisabled;  
  }

  const textAreaStyle = {
    boxShadow: 'none',
    minHeight: '40px',
    maxHeight: '100px'
  }

  // const getMaxDate = (startDate, endDate) => {
  //   const currentDate = dayjs().startOf("day"); // Get today's date (start of day)
  //   const start = dayjs(startDate).startOf("day"); // Parse start date
  //   const end = dayjs(endDate).startOf("day"); // Parse end date

  //   // Check if today's date is between startDate and endDate (inclusive)
  //   if (
  //     (currentDate.isSame(start) || currentDate.isAfter(start)) &&
  //     (currentDate.isSame(end) || currentDate.isBefore(end))
  //   ) {
  //     return end.toDate(); // Return endDate if within range
  //   }

  //   return new Date(); // Otherwise, return today's date
  // };

  return (
    <React.Fragment>
      {UploadEvidenceModalState ? (
        <UploadEvidenceForNCPointModal
          ModalState={UploadEvidenceModalState}
          ToggleFunction={
            HandleToggleUploadEvidenceModalState
          }
          ActivityObj={activityObjData}
          HandleChangeInActivityStatusTable={HandleChangeInActivityStatusTable}
          IsViewModeForFiles={
            IsAuditInClosePendingStatus ||
            IsAuditInClosedStatus || 
            IsViewMode
          }
        />
      ) : null}

      <Paper sx={{ width: "100%", mb: 2, borderRadius: "5px" }}>
        {(RequiredSearch || DataToBeExport) && (
          <div
            className="d-flex align-items-center py-2 ps-2 pe-3"
            style={{
              background: "rgba(224, 224, 224, 0.4)",
              borderRadius: "5px 5px 0 0",
            }}
          >
            <div className="d-flex align-items-center gap-1">
              {/* {RequiredSearch && (
                <MUITableSearch
                  CancelSearch={cancelSearch}
                  HandleSearch={handleSearch}
                  SearchText={searchText}
                />
              )} */}
              {DataToBeExport && (
                <AppButton
                  Type={"submit"}
                  OnPress={() => {
                    exportToExcel(RowData, Columns, FileNameForExportData);
                  }}
                  Size={"small"}
                  ClassName={"ms-2"}
                  children={"Export"}
                />
              )}
            </div>
          </div>
        )}
        <TableContainer
          style={
            RequiredSearch || DataToBeExport
              ? {}
              : {
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                }
          }
        >
          <Table
            size={DenseTable ? "small" : "medium"}
            className="rounded rounded-2"
            style={{
              minWidth: "1750px",
            }}
          >
            <TableHead style={{ background: "rgba(224, 224, 224, 0.4)" }}>
              <TableRow>
                {Columns.map((column) => (
                  <TableCell
                    key={column.id}
                    sortDirection={orderBy === column.id ? order : false}
                    style={{
                      cursor: "pointer",
                      padding: "auto",
                      fontSize: HeaderFontSize || "13px",
                    }}
                    align={column.headerAlign || "left"}
                  >
                    {column.isSort ? (
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}
                        onClick={() =>
                          handleRequestSort(
                            order,
                            orderBy,
                            column.id,
                            setOrder,
                            setOrderBy
                          )
                        }
                      >
                        <Typography
                          className="inter-medium-300"
                          variant="inherit"
                        >
                          {column.label}
                        </Typography>
                      </TableSortLabel>
                    ) : (
                      <Typography
                        className="inter-medium-300"
                        variant="inherit"
                      >
                        {column.label}
                      </Typography>
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {RowData && RowData[0] ? (
                stableSort(RowData, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    return (
                      <TableRow
                        hover={HoverEffect ? true : false}
                        role={"row"}
                        tabIndex={-1}
                        key={row.id}
                      >
                        {Columns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.cellAlign || "left"}
                            sx={{
                              padding: "auto",
                              maxWidth: column.columnWidth,
                            }}
                          >
                            {column?.id === "complianceStatus" ? (
                              <div>
                                <AppInputField
                                  Name={column.id}
                                  Id={column.id}
                                  IsSelect={true}
                                  Value={row[column.id]}
                                  SelectOptions={complianceStatusConfig || []}
                                  Disabled={
                                    !IsAuditStarted ||
                                    disableFieldsForSelectedUser() ||
                                    IsViewMode ||
                                    IsAuditee ||
                                    (IsAuditReviewedByAuditor && IsAuditor) ||
                                    (IsAuditReviewedByAuditee && IsAuditor) ||
                                    (IsAuditInClosePendingStatus &&
                                      IsAuditor) ||
                                    IsAuditInClosedStatus
                                  }
                                  PlaceHolder={"Select Progress Status"}
                                  OnChange={(event) => {
                                    const { value } = event?.target;
                                    HandleChangeInActivityStatusTable(
                                      row?.id,
                                      column.id,
                                      value
                                    );
                                  }}
                                />
                              </div>
                            ) : column.id === "capa" ? (
                              <div className="d-flex align-items-center gap-1">
                                <Input
                                  name={column.id}
                                  id={column.id}
                                  className="reactstrap-disable-input"
                                  style={textAreaStyle}
                                  type="textarea"
                                  disabled={
                                    !IsAuditStarted ||
                                    // !isCapaDisabled(row["complianceStatus"]) ||
                                    disableFieldsForSelectedUser() ||
                                    IsViewMode ||
                                    IsAuditor ||
                                    (IsAuditReviewedByAuditor && IsAuditor) ||
                                    (IsAuditReviewedByAuditee && IsAuditor) ||
                                    (IsAuditInClosePendingStatus &&
                                      IsAuditor) ||
                                    (IsAuditInClosePendingStatus &&
                                      IsAuditee) ||
                                    (IsAuditReviewPendingAtAuditor &&
                                      IsAuditee) ||
                                    (IsAuditStatusNew &&
                                      IsAuditee) ||
                                    IsAuditInClosedStatus
                                  }
                                  value={row[column.id]}
                                  onChange={(event) => {
                                    const { value } = event?.target;
                                    HandleChangeInActivityStatusTable(
                                      row?.id,
                                      column.id,
                                      value
                                    );
                                  }}
                                />
                                {((IsAuditee &&
                                  (IsAuditReviewedByAuditor ||
                                    IsAuditReviewedByAuditee ||
                                    IsAuditInClosePendingStatus ||
                                    IsAuditInClosedStatus)) ||
                                  ((IsAuditor || IsAdmin || IsSuperAdmin) &&
                                    (IsAuditInClosePendingStatus ||
                                      IsAuditInClosedStatus))) &&
                                displayEvidenceUploadIcon(
                                  row["complianceStatus"]
                                ) ? (
                                  <Tooltip title="Upload or View Evidence">
                                    {/* <IconButton
                                      style={{
                                        background: AppTheme.PRIMARY_COLOR,
                                        color: AppTheme.WHITE,
                                      }}
                                      size="small"
                                      onClick={() => {
                                        setActivityObjData(row);
                                        HandleToggleUploadEvidenceModalState();
                                      }}
                                    >
                                      <Icons.UploadIcon />
                                    </IconButton> */}
                                    <div className="cursor-pointer">
                                      {row?.evidence && row?.evidence?.length ? (
                                        <img
                                          src={UploadEditIcon}
                                          alt="Upload Evidence"
                                          style={{
                                            width: "35px",
                                            height: "35px",
                                          }}
                                          onClick={() => {
                                            setActivityObjData(row);
                                            HandleToggleUploadEvidenceModalState();
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={UploadAddIcon}
                                          alt="Upload Evidence"
                                          style={{
                                            width: "35px",
                                            height: "35px",
                                          }}
                                          onClick={() => {
                                            setActivityObjData(row);
                                            HandleToggleUploadEvidenceModalState();
                                          }}
                                        />
                                      )}
                                    </div>
                                  </Tooltip>
                                ) : null}
                              </div>
                            ) : column.id === "auditorObservation" ? (
                              <div>
                                {/* <AppInputField
                                  Name={column.id}
                                  Id={column.id}
                                  Type={"text"}
                                  IsMultiLine={true}
                                  MaxRows={5}
                                  Value={row[column.id]}
                                  Disabled={
                                    disableFieldsForSelectedUser() ||
                                    IsViewMode ||
                                    IsAuditee ||
                                    (IsAuditReviewedByAuditor && IsAuditor) ||
                                    (IsAuditReviewedByAuditee && IsAuditor) ||
                                    (IsAuditInClosePendingStatus && IsAuditor) ||
                                    IsAuditInClosedStatus
                                  }
                                  OnChange={(event) => {
                                    const { value } = event?.target;
                                    HandleChangeInActivityStatusTable(
                                      row?.id,
                                      column.id,
                                      value
                                    );
                                  }}
                                /> */}
                                <Input
                                  name={column.id}
                                  id={column.id}
                                  type="textarea"
                                  style={textAreaStyle}
                                  className="reactstrap-disable-input"
                                  value={row[column.id]}
                                  disabled={
                                    !IsAuditStarted ||
                                    disableFieldsForSelectedUser() ||
                                    IsViewMode ||
                                    IsAuditee ||
                                    (IsAuditReviewedByAuditor && IsAuditor) ||
                                    (IsAuditReviewedByAuditee && IsAuditor) ||
                                    (IsAuditInClosePendingStatus &&
                                      IsAuditor) ||
                                    IsAuditInClosedStatus
                                  }
                                  onChange={(event) => {
                                    const { value } = event?.target;
                                    HandleChangeInActivityStatusTable(
                                      row?.id,
                                      column.id,
                                      value
                                    );
                                  }}
                                />
                              </div>
                            ) : column.id === "verificationStatus" ? (
                              <div>
                                <AppInputField
                                  Name={column.id}
                                  Id={column.id}
                                  IsSelect={true}
                                  Value={row[column.id]}
                                  SelectOptions={verificationStatusConfig || []}
                                  Disabled={
                                    !IsAuditStarted ||
                                    disableFieldsForSelectedUser() ||
                                    IsAuditor ||
                                    IsViewMode ||
                                    (IsAuditStatusNew && IsAuditee) ||
                                    (IsAuditReviewedByAuditor && IsAuditor) ||
                                    (IsAuditInClosePendingStatus &&
                                      IsAuditee) ||
                                    (IsAuditReviewPendingAtAuditor &&
                                      IsAuditee) ||
                                    (IsAuditee &&
                                      varificationStatus_should_be_disable.includes(
                                        row["complianceStatus"]
                                      )) ||
                                    IsAuditInClosedStatus
                                  }
                                  PlaceHolder={"Select Varification Status"}
                                  OnChange={(event) => {
                                    const { value } = event?.target;
                                    HandleChangeInActivityStatusTable(
                                      row?.id,
                                      column.id,
                                      value
                                    );
                                  }}
                                />
                              </div>
                            ) : column.id === "remark" ? (
                              <div>
                                {/* <AppInputField
                                  Name={column.id}
                                  Id={column.id}
                                  Type={"text"}
                                  IsMultiLine={true}
                                  MaxRows={5}
                                  Value={row[column.id]}
                                  Disabled={
                                    disableFieldsForSelectedUser() ||
                                    IsAuditor ||
                                    IsViewMode ||
                                    (IsAuditStatusNew && IsAuditee) ||
                                    (IsAuditReviewedByAuditor && IsAuditor) ||
                                    (IsAuditInClosePendingStatus && IsAuditee) ||
                                    IsAuditInClosedStatus
                                  }
                                  OnChange={(event) => {
                                    const { value } = event?.target;
                                    HandleChangeInActivityStatusTable(
                                      row?.id,
                                      column.id,
                                      value
                                    );
                                  }}
                                /> */}
                                <Input
                                  name={column.id}
                                  id={column.id}
                                  type="textarea"
                                  style={textAreaStyle}
                                  className="reactstrap-disable-input"
                                  value={row[column.id]}
                                  disabled={
                                    !IsAuditStarted ||
                                    disableFieldsForSelectedUser() ||
                                    // IsAuditor ||
                                    IsAuditee ||
                                    IsViewMode ||
                                    (IsAuditStatusNew && IsAuditee) ||
                                    (IsAuditReviewedByAuditor && IsAuditor) ||
                                    (IsAuditInClosePendingStatus &&
                                      IsAuditee) ||
                                    !(
                                      IsAuditInClosePendingStatus && IsAuditor
                                    ) ||
                                    IsAuditInClosedStatus
                                  }
                                  onChange={(event) => {
                                    const { value } = event?.target;
                                    HandleChangeInActivityStatusTable(
                                      row?.id,
                                      column.id,
                                      value
                                    );
                                  }}
                                />
                              </div>
                            ) : column.id === "targetDate" ? (
                              <div>
                                <MUIDatePicker
                                  Name={column.id}
                                  Id={column.id}
                                  Value={row[column.id]}
                                  Error={false}
                                  HelperText={null}
                                  PlaceHolder={"DD/MM/YYYY"}
                                  // MinDate={dayjs(AuditData?.startDate)}
                                  // MaxDate={dayjs(getMaxDate(AuditData?.startDate, AuditData?.endDate))}
                                  Disabled={
                                    !IsAuditStarted ||
                                    disableFieldsForSelectedUser() ||
                                    !isTargetDateDisabled(
                                      row["complianceStatus"]
                                    ) ||
                                    IsViewMode ||
                                    IsAuditee ||
                                    (IsAuditReviewedByAuditor && IsAuditor) ||
                                    (IsAuditReviewedByAuditee && IsAuditor) ||
                                    (IsAuditInClosePendingStatus &&
                                      IsAuditor) ||
                                    IsAuditInClosedStatus
                                  }
                                  OnChange={(event) => {
                                    const { value } = event?.target;
                                    HandleChangeInActivityStatusTable(
                                      row?.id,
                                      column.id,
                                      addCurrentTimeInTimeStamp(value)
                                    );
                                  }}
                                />
                              </div>
                            ) : (
                              <Typography
                                className="inter-medium-300"
                                variant="inherit"
                              >
                                {row[column.id] || "Not Available"}
                              </Typography>
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    );
                  })
              ) : (
                <TableRow hover={HoverEffect ? true : false} role={"row"}>
                  <TableCell
                    align={"center"}
                    sx={{ padding: "auto" }}
                    colSpan={Columns?.length}
                  >
                    <Typography
                      variant="subtitle2"
                      className="inter-regular-400 my-3"
                    >
                      There are no records to display
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={OptionsForRowsPerPage || [5, 10, 25]}
          component="div"
          className="custom-mui-pagination"
          slotProps={{
            select: {
              MenuProps: {
                MenuListProps: {
                  classes: {
                    root: classes.menuItem,
                  },
                  sx: {
                    "& .MuiMenuItem-root": {
                      padding: "5px 8px",
                    },
                  },
                },
              },
            },
          }}
          count={RowData && RowData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(event, page) => handleChangePage(event, page, setPage)}
          onRowsPerPageChange={(event) =>
            handleChangeRowsPerPage(event, setRowsPerPage, setPage)
          }
        />
      </Paper>
    </React.Fragment>
  );
};

export default DataTableToUpdateActivityStatusForAudit;
